export const ADD_FAVORITE = 'SHOW_FAVORITE';
export const SHOW_VIDEO = 'SHOW_VIDEO';
export const UPDATE_GRID_TILE_PRODUCT = "UPDATE_GRID_TILE_PRODUCT";

/**
 * Update addFavorite value in store
 * @return {object} an object that describes the updates to be made to the store
 */
export function addFavorite() {
    return {
        type: ADD_FAVORITE,
        payload: {
            addFavorite: true
        }
    };
}

/**
 * Update showVideo value in store
 * @return {object} an object that describes the updates to be made to the store
 */
export function showVideo() {
    return {
        type: SHOW_VIDEO,
        payload: {
            showVideo: true
        }
    };
}

/**
 * Update a product in the category product list
 *
 * This is used when the product swatch is changed.  The query params
 *  need to be updated in category.products.records so that quickshop
 *  loads with the correct parameters
 *
 * @param {number} productIndex index of the product to update
 * @param {object} data data to update on the product tile
 */
export function updateGridTileProduct(productIndex, data) {
    return {
        type: UPDATE_GRID_TILE_PRODUCT,
        payload: {
            productIndex: productIndex,
            data: data
        }
    };
}
